<script setup lang="ts">
import { ref } from "vue";
import { useChatStore } from "../stores/chat";
import VdIcon from "./VdIcon.vue";

const props = withDefaults(defineProps<{ compact?: boolean; nav?: boolean; floating?: boolean }>(), { compact: false, nav: false, floating: false });
const chat = useChatStore();
const notice = ref("");
async function launch(): Promise<void> {
  await chat.init();
  if (chat.open()) { notice.value = ""; return; }
  notice.value = "Помощник временно недоступен. Рецепты и каталог продолжают работать.";
}
</script>

<template>
  <div :class="props.compact ? 'contents' : ''">
    <button
      type="button"
      :class="props.floating
        ? 'group flex items-center gap-3 rounded-full border border-vd-line bg-vd-card px-4 py-3 text-left shadow-sticky hover:border-vd-brand'
        : props.nav
        ? 'rounded-lg px-3 py-2 text-sm font-medium text-vd-muted hover:bg-vd-tint hover:text-vd-ink'
        : props.compact
          ? 'flex flex-col items-center justify-center gap-1 py-0.5 text-vd-muted'
          : 'group flex w-full items-center gap-4 rounded-vd-card border border-vd-line bg-vd-card p-4 text-left hover:border-vd-brand'"
      @click="launch"
    >
      <template v-if="props.nav">Что приготовим?</template>
      <span v-else :class="props.compact ? 'relative' : 'relative flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-vd-brand text-white shadow-sm'">
        <VdIcon name="chef-hat" :size="props.compact ? 24 : 32" />
        <VdIcon name="sparkles" :size="props.compact ? 10 : 13" class="absolute -right-1 -top-1" />
      </span>
      <span v-if="!props.compact && !props.nav" class="min-w-0">
        <strong class="block text-lg text-vd-ink">Что приготовим?</strong>
        <span class="block text-sm text-vd-muted">Рецепты и продукты</span>
      </span>
      <span v-else-if="props.compact" class="max-w-[76px] text-center text-[12px] leading-tight">Что приготовим?</span>
    </button>
    <p v-if="notice" role="status" :class="props.compact || props.nav ? 'fixed inset-x-4 bottom-20 z-50 rounded-vd-sec bg-vd-ink px-4 py-3 text-center text-sm text-vd-card shadow-sticky' : 'mt-2 text-sm text-vd-muted'">{{ notice }}</p>
  </div>
</template>
